// Makkerspillets roller (IGN-løkke runde 4): Planlæggeren bygger, Driftsvagten holder nettet kørende.
// Rollerne er mekanik, ikke et råd: hver handling hører til én af dem, og den anden kan ikke gøre den.
// Rummet (src/net/room-core.ts) håndhæver låsen, mens begge er forbundet; sim'en selv ved kun, om
// banen blev startet med roller, så determinismen ikke afhænger af, hvem der er online.

import type { ActionKind, PlayerId, State } from './types';

export const PLANNER: PlayerId = 'p1';
export const DRIFT: PlayerId = 'p2';

/** Nettet selv: ledninger, opgradering, stationer og lager (spor coop: "byg, opgradér, station"). */
const PLAN_KINDS: ReadonlySet<ActionKind> = new Set<ActionKind>([
  'build_line',
  'bury_line',
  'upgrade_line',
  'demolish',
  'upgrade_station',
  'build_battery',
]);

/**
 * Driften: storm, montører, gæster, kort, nødknapperne (Nødaflastning, Lynreserve, Norge) og
 * svinghjulet. IGN-løkke 2: "Driftsvagten har intet at lave, når et værk falder ud". Træneren gav
 * allerede svinghjulsrådet som et driftsråd, men handlingen var Planlæggerens, så hintet pegede på makkeren.
 */
const DRIFT_KINDS: ReadonlySet<ActionKind> = new Set<ActionKind>([
  'build_flywheel',
  'power_shed',
  'reinforce_mast',
  'hire_crew',
  'dispatch_crew',
  'shoo_threat',
  'answer_card',
  'power_fcr',
  'power_norway',
  // Spor: tillid. Frekvensnålen er Driftsvagtens faste opgave mellem hændelserne (hz.ts).
  'trim_hz',
]);

/** Hvis rolle handlingen er. null: begge (gave, kald året, vent). */
export function roleOf(kind: ActionKind): PlayerId | null {
  if (PLAN_KINDS.has(kind)) return PLANNER;
  if (DRIFT_KINDS.has(kind)) return DRIFT;
  return null;
}

/** Er handlingen den andens job på en bane med roller? */
export function roleBlocked(state: State, kind: ActionKind, player: PlayerId): boolean {
  if (!state.roles) return false;
  const r = roleOf(kind);
  return r !== null && r !== player;
}

/** Ticks tilbage af årsskiftet, når den første har stemt på en gave: makkeren når at svare. */
export const VOTE_TICKS = 100;

/** Hvem afgør gaven, når I stemmer forskelligt: på skift, Planlæggeren i lige år. */
export function packDecider(state: State): PlayerId {
  return state.year % 2 === 0 ? PLANNER : DRIFT;
}
